module.exports = __webpack_public_path__ + "img/octagon-fill.5aa0505d.svg";